import React from "react";
import { IIcons } from "./icons";

const LockIcon = ({ fillColor }: IIcons.IconProps) => (
  <svg
    width="22"
    height="40"
    viewBox="0 0 72 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={fillColor}
  >
    <path
      d="M35.7154 0.214844C23.8568 0.214844 14.3114 9.39314 14.3114 20.7957V34.5162C6.466 34.5162 0.0419922 40.6932 0.0419922 48.2368V75.6779C0.0419922 83.2215 6.466 89.3984 14.3114 89.3984H57.1195C64.9649 89.3984 71.3889 83.2215 71.3889 75.6779V48.2368C71.3889 40.6932 64.9649 34.5162 57.1195 34.5162V20.7957C57.1195 9.39314 47.5741 0.214844 35.7154 0.214844ZM35.7154 7.07512C43.8395 7.07512 49.9848 12.9841 49.9848 20.7957V34.5162H21.4461V20.7957C21.4461 12.9841 27.5914 7.07512 35.7154 7.07512ZM35.7154 51.6669C39.6451 51.6669 42.8501 54.7487 42.8501 58.5272C42.8501 60.9256 41.4288 63.2838 39.2828 64.3156V72.2477C39.2828 74.3112 37.8614 75.6779 35.7154 75.6779C33.5695 75.6779 32.1481 74.3112 32.1481 72.2477V64.3156C30.0021 63.2838 28.5807 60.9256 28.5807 58.5272C28.5807 54.7487 31.7858 51.6669 35.7154 51.6669Z"
      fill="#464646"
    />
  </svg>
);
export default LockIcon;
